import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../config";
import { useTranslation } from "react-i18next";

function ElderListPage() {
  const navigate = useNavigate();
  const { t } = useTranslation("profile");
  const kinkeeperID = localStorage.getItem("kinkeeperID");
  const [elders, setElders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openElderID, setOpenElderID] = useState(null);

  useEffect(() => {
    if (!kinkeeperID) {
      navigate("/login");
      return;
    }

    const fetchElders = async () => {
      try {
        const res = await axios.get(`${config.API_BASE_URL}/patients`, {
          params: { kinkeeperID }
        });

        const list = res.data.patients;
        if (!list.length) {
          navigate("/elders/new");
          return;
        }

        setElders(list);
      } catch (err) {
        alert(t("list.loadFailed"));
      } finally {
        setLoading(false);
      }
    };

    fetchElders();
  }, [kinkeeperID, navigate, t]);

  const editElder = (id) => {
    localStorage.removeItem("patientID");
    localStorage.setItem("elderID", id);
    navigate("/elders/new");
  };

  if (loading) {
    return <div className="loading-state">{t("list.loading")}</div>;
  }

  return (
    <div className="page-shell">
      <section className="page-panel">
        <div className="page-content">
          <div className="intro-badge">{t("list.badge")}</div>
          <h1 className="page-title">{t("list.title")}</h1>
          <p className="page-subtitle">
            {t("list.subtitle")}
          </p>

          <div className="list-card section-block">
            <div className="list-stack">
              {elders.map((elder) => {
                const isOpen = openElderID === elder.patientID;
                const genderLabel =
                  elder.gender === "M"
                    ? t("fields.male")
                    : elder.gender === "F"
                      ? t("fields.female")
                      : "";

                return (
                  <div key={elder.patientID} className="person-card">
                    <div className="person-header">
                      <div>
                        <div className="person-name">
                          {elder.firstName} {elder.lastName}
                        </div>
                        <div className="person-subtitle">
                          {elder.relationship || t("list.familyConnection")}
                          {elder.country ? ` - ${elder.country}` : ""}
                        </div>
                      </div>

                      <div className="person-actions">
                        <button
                          className="mini-button"
                          onClick={() => setOpenElderID(isOpen ? null : elder.patientID)}
                        >
                          {isOpen ? t("list.hideDetails") : t("list.viewDetails")}
                        </button>

                        <button className="ghost-button" onClick={() => editElder(elder.patientID)}>
                          {t("list.editProfile")}
                        </button>
                      </div>
                    </div>

                    {isOpen && (
                      <div className="person-content">
                        <div className="details-grid">
                          <Field label={t("fields.email")} value={elder.email} />
                          <Field label={t("fields.relationship")} value={elder.relationship} />
                          <Field label={t("fields.language")} value={elder.spokenLanguage} />
                          <Field label={t("fields.gender")} value={genderLabel} />
                          <Field label={t("fields.country")} value={elder.country} />
                          <Field label={t("fields.state")} value={elder.stateProvince} />
                          <Field label={t("fields.city")} value={elder.city} />
                          <Field label={t("fields.whatsapp")} value={elder.whatsapp} />
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          <div className="button-row">
            <button
              className="button"
              onClick={() => {
                localStorage.removeItem("elderID");
                localStorage.removeItem("patientID");
                navigate("/elders/new");
              }}
            >
              {t("list.addNew")}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

const Field = ({ label, value }) => {
  if (!value) return null;

  return (
    <div className="detail-card">
      <div className="field-label">{label}</div>
      <div className="detail-value">{value}</div>
    </div>
  );
};

export default ElderListPage;
